
export default [
  {
    title: 'مدیریت کاربران',
    icon: 'UsersIcon',
    route:'users-list'
  },
  {
    title: 'مدیریت محتوا',
    icon: 'FileIcon',
    tag:parseInt(localStorage.getItem('commentsCount')) !== 0 ? 'جدید' : '',
    tagVariant: 'light-success',
    children: [
      {
        title: 'دسته بندی',
        route: 'categories-list',
      },
      {
        title: 'محتوا ',
        route: 'contents-list',
      },
      {
        title: 'نظرات ',
        tag:localStorage.getItem('commentsCount')?.toString(),
        tagVariant: 'light-danger',
        route: 'contents-comments',
      },
    ],
  },
  {
    title: 'مدیریت گالری',
    icon: 'ImageIcon',
    tag: parseInt(localStorage.getItem('galleryCommentsCount')) !== 0 ? 'جدید' : '',
    children: [
      {
        title: 'محتوا',
        route: 'gallery-list',
      },
      {
        title: 'نظرات ',
        tag:localStorage.getItem('galleryCommentsCount')?.toString(),
        tagVariant: 'light-danger',
        route: 'gallery-comments',
      },
    ],
  },
  {
    title: 'تقویم بارداری',
    icon: 'LayoutIcon',
    // tag: parseInt(localStorage.getItem('galleryCommentsCount')) !== 0 ? 'جدید' : '',
    children: [
      {
        title: 'کاربران',
        children: [
          {
            title: 'اطلاعات مادران',
            route: 'calendar-mother-list',
          },
          {
            title: 'اطلاعات نوزادان',
            route: 'calendar-children-list',
          },
        ]
      },
      // {
      //   title: 'محتوا',
      //   route: 'gallery-list',
      // },
      // {
      //   title: 'اطلاعات فرزند ',
      //   // tag:localStorage.getItem('galleryCommentsCount')?.toString(),
      //   // tagVariant: 'light-danger',
      //   route: 'calendar-child-list',
      // },
    ],
  },
  {
    title: 'مدیریت کتابخانه',
    icon: 'BookOpenIcon',
    route: 'library-list'
    // tag: parseInt(localStorage.getItem('galleryCommentsCount')) !== 0 ? 'جدید' : '',
    // children: [
    //   {
    //     title: 'محتوا',
    //     route: 'gallery-list',
    //   },
    //   {
    //     title: 'اطلاعات فرزند ',
    //     // tag:localStorage.getItem('galleryCommentsCount')?.toString(),
    //     // tagVariant: 'light-danger',
    //     route: 'calendar-child-list',
    //   },
    // ],
  },
  {
    title: 'مدیریت اشتراک ها',
    icon: 'KeyIcon',
    route:'subscription-list'

    // children: [
    //   {
    //     title: 'محتوا',
    //     route: 'gallery-list',
    //   },
    // ],
  },
  {
    title: 'ارسال نوتیفیکشن',
    icon: 'BellIcon',
    route:'notification-list'

    // children: [
    //   {
    //     title: 'محتوا',
    //     route: 'gallery-list',
    //   },
    // ],
  },
  {
    title: 'کد تخفیف',
    icon: 'DollarSignIcon',
    route:'discount-list'

    // children: [
    //   {
    //     title: 'محتوا',
    //     route: 'gallery-list',
    //   },
    // ],
  },
  {
    title: 'گزارشات',
    icon: 'ClipboardIcon',
    route:'report-list'

    // children: [
    //   {
    //     title: 'محتوا',
    //     route: 'gallery-list',
    //   },
    // ],
  },
  {
    title: 'تنظیمات',
    icon: 'SettingsIcon',
    route:'settings-edit'

    // children: [
    //   {
    //     title: 'محتوا',
    //     route: 'gallery-list',
    //   },
    // ],
  },

  {
    title: 'بروزرسانی وردپرس',
    icon: 'DownloadCloudIcon',
    route:'wordpress-fetch'
  },
]
